import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { useClipboard } from '@root/shared'

type Props = {
  googleAuthCode: string
  onShowQr: () => void
}

export const SetupOtpInstructionsActions: React.FC<Props> = ({
  googleAuthCode,
  onShowQr,
}) => {
  const { t } = useTranslation()

  const [copied, setCopied] = useState(false)
  const { copyToClipboard } = useClipboard()

  const handleCopyAndNotify = async () => {
    const isCopied = await copyToClipboard(googleAuthCode, {
      snackbarText: t('mfa.code_copied_message'),
    })

    if (isCopied) {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }
  }
  return (
    <Root>
      <Code>{googleAuthCode}</Code>
      <Actions>
        <Button
          variant="soft"
          size="xs"
          onClick={handleCopyAndNotify}
          radius="rounded"
        >
          {copied ? t('common.copied-to-clipboard') : t('mfa.copy_key')}
        </Button>
        <Button variant="soft" size="xs" onClick={onShowQr} radius="rounded">
          {t('mfa.qr_core')}
        </Button>
      </Actions>
    </Root>
  )
}

const Root = styled.div``

const Code = styled.div`
  color: var(--text-12);

  font-weight: 700;
  font-size: 18px;
  margin: 10px 0;

  word-break: break-all;
`

const Actions = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`
